module.exports = __webpack_public_path__ + "static/img/autocred.68fcbd82.svg";